/**Dependencies */
import React, { useEffect, useState } from "react";

// Styles
import { Button, Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {
  Currency,
  fetchMarkup,
  FormatCancellationPolicies,
  FormatDate,
} from "../helpers";
import { getHotelesRate } from "../services/searchService";
import Swal from "sweetalert2";

export const Preventa = () => {
  const [dataCart, setDataCart] = useState(
    JSON.parse(sessionStorage.getItem("datosReserva"))
  );
  const [dataUrl, setDataUrl] = useState("");
  const [totalReserva, setTotalReserva] = useState(0);
  const [totalHospedaje, setTotalHospedaje] = useState(0);
  const [markup, setMarkup] = useState(0);
  const [nights, setNights] = useState(0);
  const [checkRates, setCheckRates] = useState();
  const [messageButton, setMessageButton] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMarkupPanel = async () => {
      try {
        const markupData = await fetchMarkup();
        setMarkup(markupData.markup);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchMarkupPanel();
  }, []);

  useEffect(() => {
    const hospedaje = precioHospedajes();
    setTotalReserva(hospedaje);
    setTotalHospedaje(hospedaje);
  }, [dataCart]);

  useEffect(() => {
    if (dataCart) {
      const nights = dataCart?.hospedaje?.reduce(
        (total, item) => total + Number(item?.noches),
        0
      );
      setNights(nights);
    }
  }, [dataCart]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const checkRate = await fetchHotelRates();

        // Si checkRate.habitacion no existe o está vacía
        // if (!checkRate?.habitacion || checkRate.habitacion.length === 0) {
        //   setCheckRates([]);
        //   // return;
        // }
        // Verificar qué habitaciones siguen disponibles
        const habitacionesDisponibles = checkRate?.map(
          (h) => h.habitacion?.code
        );

        // Verificar si alguna del carrito ya no está en las disponibles
        const nuevasHabitaciones = dataCart?.hospedaje?.filter((item) =>
          habitacionesDisponibles.includes(item.idHab)
        );

        // Si hay habitaciones eliminadas
        if (nuevasHabitaciones.length !== dataCart.hospedaje.length) {
          Swal.fire({
            icon: "warning",
            title: "Habitaciones eliminadas",
            text: "Algunas habitaciones han sido eliminadas del carrito debido a cambios en la disponibilidad.",
            timer: 5000,
            showConfirmButton: false,
          });

          const nuevoDataCart = { hospedaje: nuevasHabitaciones };

          // Actualizar sessionStorage y estado
          sessionStorage.setItem("datosReserva", JSON.stringify(nuevoDataCart));
          window.dispatchEvent(new Event("sessionStorageChange"));
          setDataCart(nuevoDataCart);

          // Si ya no queda ninguna habitación, redirigir
          if (nuevasHabitaciones.length === 0) {
            navigate(`/hotel${dataCart?.url[0]?.urlHotel[1]}`);
          }
        }

        setCheckRates(checkRate);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataCart]);

  const fetchHotelRates = async () => {
    const rates = construirRequest();
    try {
      const response = await getHotelesRate(rates);
      return response;
    } catch (error) {
      console.error("Error fetching rates:", error);
      return [];
    }
  };

  const construirRequest = () => {
    const rateKeys = dataCart?.hospedaje?.map((item) => ({
      rateKey: item.rateKey,
    }));
    // Construir el objeto final
    const request = {
      habitaciones: rateKeys,
    };
    return request;
  };
  const deleteHab = (idHab) => {
    const dataSession = dataCart;

    const newData = dataSession.hospedaje.filter(
      (item) => item.idHab !== idHab
    );
    const setData = {
      hospedaje: newData,
    };

    if (setData.hospedaje.length < 1) {
      sessionStorage.setItem("datosReserva", JSON.stringify(setData));
      window.dispatchEvent(new Event("sessionStorageChange"));
      setDataCart(setData);
      navigate("/");
    } else {
      sessionStorage.setItem("datosReserva", JSON.stringify(setData));
      window.dispatchEvent(new Event("sessionStorageChange"));
      setDataCart(setData);
    }
  };

  const precioHospedajes = () => {
    if (!dataCart || !dataCart.hospedaje) return 0; // Evita errores si no hay datos
    const total = dataCart?.hospedaje?.reduce(
      (total, item) => total + item.totalPrices,
      0
    );
    return total;
  };

  const deleteUrlSession = () => {
    sessionStorage.removeItem("urlSession");
  };
  const agregarCheckRateAlCart = () => {
    const habitacionesConRate = dataCart?.hospedaje?.map((item) => {
      const habitacionMatch = checkRates?.find(
        (h) => h?.habitacion?.code === item?.idHab
      );

      // Si se encuentra el rate correspondiente, lo añadimos al item
      if (habitacionMatch) {
        return {
          ...item,
          comentario: habitacionMatch.habitacion.rates[0].rateComments, // o habitacionMatch completo si necesitas más info
        };
      }
      return item; // si no hay match, lo dejamos igual
    });

    const newCart = {
      ...dataCart,
      hospedaje: habitacionesConRate,
    };

    // Guardar en sessionStorage y actualizar estado
    sessionStorage.setItem("datosReserva", JSON.stringify(newCart));
    window.dispatchEvent(new Event("sessionStorageChange"));
    setDataCart(newCart);
  };
  return (
    <div className="container position-relative" style={{ marginTop: "45px" }}>
      <Row>
        <Col lg={12}>
          <h1 className="p-5 fw-lighter" style={{ fontSize: "20px" }}>
            Felicidades, estás a un paso de iniciar tu aventura.
            <br />
            <span>
              ¿Alguna duda? Comunícate y con gusto te acompañamos durante tu
              compra: 777 312 8531
            </span>
            {dataCart.hospedaje.length > 0 ? (
              <></>
            ) : (
              <Link className="ps-2" to={dataUrl} onClick={deleteUrlSession}>
                <Button
                  className="btn-purple w-auto"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  {messageButton}
                </Button>
              </Link>
            )}
          </h1>
        </Col>
        {dataCart?.hospedaje?.length > 0 && (
          <Col lg={12}>
            <Row className="justify-content-center">
              <Col lg={12}>
                <h2 className="fw-bold" style={{ fontSize: "25px" }}>
                  Hospedaje
                </h2>
              </Col>
              {dataCart.hospedaje?.map((info, index) => {
                const comment = checkRates?.find(
                  (hab) => hab?.habitacion?.code == info?.idHab
                )?.habitacion?.rates[0]?.rateComments;
                return (
                  <>
                    <Row
                      key={index + 1}
                      style={{
                        padding: "20px",
                        border: "2px solid #d80100",
                        backgroundColor: "#fff",
                        marginBottom: "20px",
                      }}
                    >
                      <Col lg={12}>
                        <h2>Habitación {index + 1}</h2>
                      </Col>
                      <Col lg={3}>
                        <img src={info.imgHab} className="w-100" alt="" />
                      </Col>
                      <Col lg={7}>
                        <Row>
                          <Col lg={7}>
                            <div className="pt-3 pt-lg-0">
                              <p
                                className="fw-bolder"
                                style={{ fontSize: "16px" }}
                              >
                                <span className="text-secondary fw-lighter">
                                  Habitacion:{" "}
                                </span>
                                {info.nombreHab}
                              </p>
                              <p
                                className="fw-bolder"
                                style={{ fontSize: "16px" }}
                              >
                                <span className="text-secondary fw-lighter">
                                  Hotel:
                                </span>{" "}
                                {info.nombre}
                              </p>
                              <p
                                className="fw-bolder"
                                style={{ fontSize: "16px" }}
                              >
                                <span className="text-secondary fw-lighter">
                                  Destino:
                                </span>{" "}
                                {info.destino}
                              </p>
                              <p
                                className="fw-bolder"
                                style={{ fontSize: "16px" }}
                              >
                                <span className="text-secondary fw-lighter">
                                  Plan de alimentos:
                                </span>{" "}
                                {info?.rates?.[0]?.boardName}
                              </p>
                              <p
                                className="fw-bolder"
                                style={{ fontSize: "16px" }}
                              >
                                <span className="text-secondary fw-lighter">
                                  Precio de la habitacion:
                                </span>{" "}
                                {Currency(info.totalPrices)}{" "}
                                <span style={{ fontSize: "14px" }}>MXN</span>
                              </p>
                            </div>
                          </Col>
                          <Col lg={5}>
                            <div>
                              <p
                                className="fw-bolder"
                                style={{ fontSize: "16px" }}
                              >
                                <span className="text-secondary fw-lighter">
                                  Check in:
                                </span>{" "}
                                {FormatDate(info.checkIn)}
                              </p>
                              <p
                                className="fw-bolder"
                                style={{ fontSize: "16px" }}
                              >
                                <span className="text-secondary fw-lighter">
                                  Check out:
                                </span>{" "}
                                {FormatDate(info.checkOut)}
                              </p>
                              <p
                                className="fw-bolder"
                                style={{ fontSize: "16px" }}
                              >
                                <span className="text-secondary fw-lighter">
                                  Adultos:
                                </span>{" "}
                                {info.paxes[0].adults}
                              </p>
                              <p
                                className="fw-bolder"
                                style={{ fontSize: "16px" }}
                              >
                                <span className="text-secondary fw-lighter">
                                  Menores:
                                </span>{" "}
                                {info.paxes[0].minors}{" "}
                                <span className="text-secondary fw-lighter">
                                  | Edades:
                                </span>{" "}
                                {info.paxes[0]?.ages ? info.paxes[0]?.ages : 0}
                              </p>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg={12}>
                        <div className="pt-3">
                          <h3>Politicas de cancelación</h3>
                          <p style={{ fontSize: "17px", textAlign: "justify" }}>
                            Aplica penalidad a partir del{" "}
                            <strong>
                              {FormatCancellationPolicies(
                                info?.cancellationPolicies?.[0]?.from
                              )}
                            </strong>
                            . Fecha y hora calculados en base a la hora local en
                            destino.{" "}
                            <strong style={{ fontSize: "18px" }}>
                              {" "}
                              {Currency(
                                info?.cancellationPolicies?.[0]?.amount
                              )}{" "}
                              <span style={{ fontSize: "14px" }}>MXN</span>
                            </strong>{" "}
                            de penalidad por cancelación.
                          </p>
                        </div>
                        <div>
                          <h3>Comentarios</h3>
                          <p style={{ fontSize: "17px" }}>{comment}</p>
                        </div>
                      </Col>
                      <Col lg={12} className="d-flex justify-content-end">
                        <Button
                          className="btn-danger d-flex justify-content-end"
                          onClick={() => deleteHab(info.idHab)}
                          style={{ fontSize: "17px" }}
                        >
                          Eliminar
                        </Button>
                      </Col>
                    </Row>
                  </>
                );
              })}
            </Row>
          </Col>
        )}
        <Col lg={12}>
          <Row
            className="justify-content-end"
            style={{
              padding: "20px",
              border: "2px solid #d80100",
              backgroundColor: "#fff",
              marginBottom: "20px",
            }}
          >
            <Col lg={12}>
              <h2
                className="fw-bold"
                style={{
                  borderBottom: "2px solid #d80100",
                  paddingBottom: "10px",
                  marginBottom: "15px",
                  fontSize: "25px",
                }}
              >
                Total a pagar
              </h2>
            </Col>
            {dataCart?.hospedaje?.length > 0 && (
              <Col lg={3}>
                <h4 style={{ fontSize: "20px" }}>
                  <strong>Tu hospedaje en</strong>{" "}
                  <span className="text-secondary">
                    {" "}
                    <br />
                    {dataCart?.hospedaje?.[0]?.destino}
                  </span>
                </h4>
              </Col>
            )}
            <Col lg={3}>
              <h3>
                <span style={{ fontSize: "20px", lineHeight: "35px" }}>
                  Reserva:
                </span>{" "}
                <br />
                {dataCart?.hospedaje?.length > 0 && (
                  <>
                    <span
                      style={{
                        fontSize: "18px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      Hospedaje:{" "}
                      <span>
                        <span style={{ fontWeight: "bold" }}>
                          {Currency(totalHospedaje)}
                        </span>{" "}
                        <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                          MXN
                        </span>
                      </span>
                    </span>
                  </>
                )}
                <hr
                  style={{
                    color: "#d80100",
                    opacity: "1",
                    width: "100%",
                  }}
                />
                <hr
                  style={{
                    color: "#d80100",
                    opacity: "1",
                    width: "100%",
                  }}
                />
                <span
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  Total:{" "}
                  <span>
                    <span style={{ fontWeight: "bold", fontSize: "30px" }}>
                      {Currency(totalReserva)}{" "}
                    </span>
                    <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                      MXN
                    </span>
                  </span>
                </span>
              </h3>
            </Col>
            <Col lg={2}>
              <br />
              <br />
              <br />
              <Button
                className="btn-blue w-auto rounded-3"
                style={{ fontSize: "17px" }}
                onClick={() => [
                  agregarCheckRateAlCart(),
                  window.scrollTo(0, 0),
                  navigate("/checkout"),
                ]}
              >
                Continuar
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};
